import { DOC, DOCX, JPG_JPEG, PDF, PNG } from "core/consts";
import { List } from "immutable";

/**
 * File Feature v1
 */

export type FileMimeType = (typeof FileMimeTypes)[keyof typeof FileMimeTypes];
export const FileMimeTypes = {
  DOC: "application/msword",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  JPG_JPEG: "image/jpeg",
  PDF: "application/pdf",
  PNG: "image/png",
  TIFF: "image/tiff",
  XL: "application/excel",
  XL2: "application/x-excel",
  XL3: "application/x-msexcel",
  XL4: "application/vnd.ms-excel",
  XLS: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
} as const;

export const mimeTypeToExtensionMap: { [key in FileMimeType]: string } = {
  [FileMimeTypes.DOC]: ".doc",
  [FileMimeTypes.DOCX]: ".docx",
  [FileMimeTypes.JPG_JPEG]: ".jpg",
  [FileMimeTypes.PDF]: ".pdf",
  [FileMimeTypes.PNG]: ".png",
  [FileMimeTypes.TIFF]: ".tiff",
  [FileMimeTypes.XL]: ".xls",
  [FileMimeTypes.XL2]: ".xls",
  [FileMimeTypes.XL3]: ".xls",
  [FileMimeTypes.XL4]: ".xls",
  [FileMimeTypes.XLS]: ".xlsx",
};

export const ALLOWED_FILE_MIME_TYPES = List(Object.values(FileMimeTypes));

/**
 * File Feature v2
 */

export const ALLOWED_EXTENSIONS_HIS = ["pdf", "doc", "docx"] as const;

/**
 * DTA AHB Message Section - allows all file types except Word documents
 */
export const ALLOWED_FILE_MIME_TYPES_AHB = [
  FileMimeTypes.PDF,
  FileMimeTypes.JPG_JPEG,
  FileMimeTypes.PNG,
  FileMimeTypes.TIFF,
  FileMimeTypes.XL,
  FileMimeTypes.XL2,
  FileMimeTypes.XL3,
  FileMimeTypes.XL4,
  FileMimeTypes.XLS,
] as const;

export const BYTES_PER_MB = 1024 * 1024;

export const MAX_FILE_SIZE_MB = 21;
export const MAX_FILE_SIZE_AHB_MB = 8;

export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1e6; // 21MB in bytes
export const MAX_FILE_SIZE_AHB = MAX_FILE_SIZE_AHB_MB * 1e6; // 8MB in bytes

export const ACCEPT_ATTRIBUTE_IMAGE = [JPG_JPEG, PNG];
export const ACCEPT_ATTRIBUTE_DOCUMENT = [PDF, DOC, DOCX];
export const IMAGE_MAX_WIDTH = 4000;
export const IMAGE_MAX_HEIGHT = 3000;
export const IMAGE_MAX_FILE_SIZE_MB = 15;
